<mat-form-field class="w-100" appearance="outline">
    <mat-label class="LabelTitulo">{{titulo}}</mat-label>
    <mat-select *ngIf="!multiples" class="SelectLista med" [disabled]="disabled" [(value)]="selection"
        [required]="!optional">
        <mat-option *ngIf="search">
            <ngx-mat-select-search [formControl]="DataFilterCtrl" placeholderLabel="Buscar"
                noEntriesFoundLabel="No se encontraron datos">
            </ngx-mat-select-search>
        </mat-option>
        <mat-option (click)="onClick(undefined)" class="SelectOption" *ngIf="optional" [disabled]="disabled">Seleccione
        </mat-option>
        <mat-option (click)="onClick(item)" class="SelectOption" *ngFor="let item of items$ | async"
            [value]="item[value]">
            {{item[text]}}
        </mat-option>
    </mat-select>
    <mat-select *ngIf="multiples" class="SelectLista" [disabled]="disabled" [(ngModel)]="selectionCheck"
        [required]="!optional" [multiple]="true" #multiSelect>
        <mat-option *ngIf="search">
            <ngx-mat-select-search [formControl]="DataFilterCtrlCheck" placeholderLabel="Buscar"
                noEntriesFoundLabel="No se encontraron datos">
            </ngx-mat-select-search>
        </mat-option>
        <mat-option (click)="onClick2(item)" class="SelectOption" *ngFor="let item of itemsCheck$ | async"
            [value]="item">
            {{item.x[text]}}
        </mat-option>
    </mat-select>
    <mat-spinner matPrefix *ngIf="!items$" diameter="20"></mat-spinner>

</mat-form-field>
